import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { InterfaceSettingsUserColumns } from '@app/modules/table/table.interface';
import { TreeNode } from '../../dialogs/settings-table/interfaces/settings.table.dialog.interface';

/**
 * Компонент, отвечающий за определение, какой из рендеров ячеек в табличном движке использовать для ячейки.
 */
@Component({
    selector: 'app-switcher-cell',
    templateUrl: './switcher-cell.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SwitcherCellComponent {
    @Input() column: InterfaceSettingsUserColumns | null;
    @Input() row: any;
    @Input() isLastElement: boolean;
    @Input() unitedColumn: boolean;

    /**
     * Обработка datetime vs dateTime
     */
    get columnType() {
        return typeof this.column.type === 'string' ? this.column.type.toLowerCase() : this.column.type;
    }

    /**
     * Получить только те колонки, для которых есть значения
     * @param columns Список колонок объединенного столбца
     */
    public getNotNullColumns(columns: TreeNode[]) {
        return columns.filter((column) => !!this.row[column.alias]);
    }
}
